import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { StoreService } from './store.service';

import { environment } from '../../environments/environment';

@Injectable()
export class IpService {

    url = environment.ipUrl;

    constructor(private http: HttpClient,
                private store: StoreService) {
    }

    getIp(): Observable<any> {
        return this.http.get(this.url).pipe(
            catchError((error: HttpErrorResponse) => observableThrowError(error.error || 'Server error')));
    }

}